module.exports = __webpack_public_path__ + "static/media/img-logista-small.b8bcf00f.b8bcf00f.JPG";